export const RENT_FLOW_STEP_TYPE = Object.freeze({
  NEGOTIATING_TERMS: 'NEGOTIATING_TERMS',
  SUPPLY_DOCUMENTATION: 'SUPPLY_DOCUMENTATION',
  DEMAND_DOCUMENTATION: 'DEMAND_DOCUMENTATION',
  DEMAND_CREDIT: 'DEMAND_CREDIT',
  GUARANTEE_PAYMENT: 'GUARANTEE_PAYMENT',
  DEMAND_ADVANCE_PAYMENT: 'DEMAND_ADVANCE_PAYMENT',
  CONTRACT_DRAFT: 'CONTRACT_DRAFT',
  DEMAND_CONTRACT_SIGNING: 'DEMAND_CONTRACT_SIGNING',
  SUPPLY_CONTRACT_SIGNING: 'SUPPLY_CONTRACT_SIGNING',
  DEMAND_RESERVATION: 'DEMAND_RESERVATION',
});
